export default "__VITE_ASSET__e6150ca6__"